import React from 'react'
import { TopBar } from 'prove-common'
import { AppLogo } from '../app-logo/AppLogo'
import { useParams } from 'react-router'

export const ChangelogScreenTopBar: React.FC = () => {
  const { sampleId } = useParams()
  const breadcrumbItems = [
    {
      label: 'Prøver',
      to: '/samples'
    },
    {
      label: '#' + sampleId,
      to: `/samples/${sampleId}`
    },
    {
      label: 'Endringslogg'
    }
  ]
  return <TopBar logo={<AppLogo />} breadcrumbItems={breadcrumbItems} />
}
